/** WCAG 1.4.10 — Multimedia8 phone frame must fit without horizontal scroll. */
export const PHONE_FRAME_WIDTH_PX = 345;
export const PHONE_FRAME_HEIGHT_PX = 639;

/**
 * Horizontal gutter for LayoutColumns `px: md` (16+16) — keep in sync with
 * theme space.md / LayoutColumns defaults.
 */
export const PHONE_VIEWPORT_GUTTER_PX = 32;

/** Scale factor so the fixed 345px phone frame fits in the CSS viewport. */
export function getPhoneFitScale(
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : Infinity
): number {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) return 1;
  return Math.min(
    1,
    (viewportWidth - PHONE_VIEWPORT_GUTTER_PX) / PHONE_FRAME_WIDTH_PX
  );
}
